export default {
  localhost: 'http://localhost:5333/',
  'admin.electrafk.cl': 'https://api-shop.electrafk.cl/',
  'admin.sonepar.cl': 'https://api-shop.sonepar.cl/',
  'homolog-admin.electrafk.cl': 'https://homolog-api-shop.electrafk.cl/',
  'homolog-admin.sonepar.cl': 'https://homolog-api-shop.sonepar.cl/',
  'homolog2-admin.electrafk.cl': 'https://homolog2-api-shop.electrafk.cl/',
  'homolog2-admin.sonepar.cl': 'https://homolog2-api-shop.sonepar.cl/',
};
